import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { transition, trigger, style, animate } from '@angular/animations';
import { ViewUI } from '../../models/view-ui.enum';
import { ViewService } from '../../view.service';
import { ViewUIService } from '../../view-ui.service';
import { Select, Store } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { LayoutStateModel } from 'src/app/layout/state/layout.state.model';
import { takeUntil } from 'rxjs/operators';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { ViewUIModel } from '../../models/view-ui.model';
import { ViewUIStatus } from '../../models/view-ui-status.enum';

@Component({
  selector: 'app-view-column-toggle',
  templateUrl: './view-column-toggle.component.html',
  styleUrls: ['./view-column-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('show', [
      transition(':enter', [
        style({ 
          opacity: 0,
          transform: 'translateX(-32px)'
        }),
        animate('300ms ease-in-out', style({ 
          opacity: 1,
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ 
          transform: 'translateX(-32px)',
          opacity: 0 
        }))
      ])
    ])
  ]
})
export class ViewColumnToggleComponent implements OnInit, OnDestroy {
  @Select(ViewState.getUI)
  layout$: Observable<ViewUIModel>;

  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  ngUnsubscribe = new Subject();
  isIn = false;
  columnToggleVisible = false;

  constructor(
    private viewService: ViewService,
    private layoutService: ViewUIService,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store
  ) { }

  ngOnInit() {
    combineLatest(this.chapter$, this.layout$)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe(([chapter, layout]) => {
        this.isIn = layout.column.status === ViewUIStatus.Collapse;
        
        this.columnToggleVisible = this.layoutService.isVisible(ViewUI.ColumnToggle);

        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isVisible() {
    return this.layoutService.isVisible(ViewUI.ColumnToggle);
  }

  handleToggle() {
    this.viewService.toggleColumn();
    this.viewService.toggleSearch(false);
    this.viewService.toggleNodeInfo(false);
    this.viewService.toggleLabelInfo(false);

    this.changeDetectorRef.markForCheck();
  }

}
